module.exports = __webpack_public_path__ + "static/media/heat_recovery_bg_icon_svg.a623d977.svg";